import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "eLvIeKFyDCb1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "0 0 725 760",
  "shape-rendering": "geometricPrecision",
  "text-rendering": "geometricPrecision"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M90.10284,620.10734q-37.104386-37.104385-31.396019-77.062954c5.708367-39.958569,13.971378-54.440425,28.242295-71.259314s32.490474-23.508573,31.695559-38.626751-16.232058-26.626435-34.880899-37.821423-59.247335-38.861156-66.442615-57.793724-11.416743-72.781687-4.281284-92.760971s10.379141-31.764507,27.181153-45.436616s36.019929-18.957858,60.033215-24.013286s58.137429-11.374715,79.623001-24.013286s43.682268-38.647849,65.088644-54.345858s44.235001-25.277143,71.40793-19.589786s40.522625,21.912246,61.929001,34.756072s32.860286,16.430143,48.6585,16.430143s41.642091-19.836125,53.058825-38.388318s26.756861-51.602517,42.046496-61.795607s24.845656-15.289635,41.830654-19.073595s32.629098-2.892633,51.181291-.038449s43.957701,14.015499,56.061995,24.845657s19.112043,35.675814,16.913692,56.537021-3.426316,49.197168-2.261125,68.32833s5.115311,48.693194,9.396586,70.09957s15.44907,62.410599,17.1251,78.490046s2.783447,56.546319-8.683779,85.851452-24.844177,45.791688-60.521471,64.34388-87.278333,29.305134-119.131739,43.9577-57.334651,30.01794-93.011945,47.143041-64.980948,27.393929-86.004196,36.949951-50.784754,30.005793-55.066029,49.985078s7.97348,21.544752,19.390214,25.826028s29.305133,10.830159,42.683564,17.837908s17.843361,29.117743,3.572443,41.961569-19.191756,24.293515-57.723233,24.293515-59.314493-9.311382-73.262834-21.660316c-24.514037-21.703098-34.755572-31.055637-50.453581-46.753646s-38.098888-35.428141-59.122136-42.435891q-21.023248-7.00775-24.877273-14.76717Z",
  transform: "translate(2.000008 4.000007)",
  fill: "none",
  stroke: "rgb(241, 238, 233)",
  "stroke-width": "17",
  "stroke-dasharray": "2549.85"
}, null, -1)

import { onUpdated, ref } from 'vue'
import { gsap } from 'gsap'

interface Props {
  currentStop: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LakePath',
  props: {
    currentStop: null
  },
  setup(__props: any) {

const props = __props as {
  currentStop: number
}


const element = ref(null)
let lastStop = 0

const pathLengthsPerStop = [
  2549.85, 2167.38, 1742.4, 1402.42, 467.47, 339.98, 0,
]

onUpdated(() => {
  if (element.value) {
    gsap.to(element.value, {
      'stroke-dashoffset': pathLengthsPerStop[props.currentStop],
      duration: 1.0,
    })
  }
  lastStop = props.currentStop
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("path", {
      ref_key: "element",
      ref: element,
      d: "M90.10284,620.10734q-37.104386-37.104385-31.396019-77.062954c5.708367-39.958569,13.971378-54.440425,28.242295-71.259314s32.490474-23.508573,31.695559-38.626751-16.232058-26.626435-34.880899-37.821423-59.247335-38.861156-66.442615-57.793724-11.416743-72.781687-4.281284-92.760971s10.379141-31.764507,27.181153-45.436616s36.019929-18.957858,60.033215-24.013286s58.137429-11.374715,79.623001-24.013286s43.682268-38.647849,65.088644-54.345858s44.235001-25.277143,71.40793-19.589786s40.522625,21.912246,61.929001,34.756072s32.860286,16.430143,48.6585,16.430143s41.642091-19.836125,53.058825-38.388318s26.756861-51.602517,42.046496-61.795607s24.845656-15.289635,41.830654-19.073595s32.629098-2.892633,51.181291-.038449s43.957701,14.015499,56.061995,24.845657s19.112043,35.675814,16.913692,56.537021-3.426316,49.197168-2.261125,68.32833s5.115311,48.693194,9.396586,70.09957s15.44907,62.410599,17.1251,78.490046s2.783447,56.546319-8.683779,85.851452-24.844177,45.791688-60.521471,64.34388-87.278333,29.305134-119.131739,43.9577-57.334651,30.01794-93.011945,47.143041-64.980948,27.393929-86.004196,36.949951-50.784754,30.005793-55.066029,49.985078s7.97348,21.544752,19.390214,25.826028s29.305133,10.830159,42.683564,17.837908s17.843361,29.117743,3.572443,41.961569-19.191756,24.293515-57.723233,24.293515-59.314493-9.311382-73.262834-21.660316c-24.514037-21.703098-34.755572-31.055637-50.453581-46.753646s-38.098888-35.428141-59.122136-42.435891q-21.023248-7.00775-24.877273-14.76717Z",
      transform: "translate(2.000008 4.000007)",
      fill: "none",
      stroke: "#f6bb45",
      "stroke-width": "17",
      "stroke-dasharray": "2549.85",
      "stroke-dashoffset": "2549.85",
      pathLength: "2549.85"
    }, null, 512)
  ]))
}
}

})